import { stateAbbreviations } from '@constants/stateAbbreviations'

export const terminalCreateConfig = (createSelectOptions) => {
  return [
    {
      step_title: 'Name',
      form_title: 'Identify Terminal',
      section: [
        {
          name: 'name',
          input: 'input',
          placeholder: 'Enter Name',
          rules: [
            {
              required: true,
              message: 'Terminal name is required',
            },
          ],
        },
        {
          name: 'short_name',
          input: 'input',
          placeholder: 'Enter Short Name',
          maxLength: 10,
          rules: [
            {
              required: true,
              message: 'Short name is required, 10 character max',
            },
          ],
        },
        {
          name: 'tcn',
          input: 'input',
          placeholder: 'Enter TCN',
        },
        {
          name: 'type',
          input: 'select',
          placeholder: 'Select Type',
          type: 'single',
          options: createSelectOptions.type,
          rules: [
            {
              required: true,
              message: 'Terminal type is required',
            },
          ],
        },
        {
          name: 'market',
          input: 'select',
          type: 'single',
          placeholder: 'Select Market',
          options: createSelectOptions.market_names,
          rules: [
            {
              required: true,
              message: 'Market is required',
            },
          ],
        },
      ],
    },
    {
      step_title: 'Location',
      form_title: 'Terminal Location',
      section: [
        {
          name: 'address',
          input: 'input',
          type: 'text',
          placeholder: 'Enter Address',
        },
        {
          name: 'city',
          input: 'input',
          placeholder: 'Enter City',
        },
        {
          name: 'state',
          input: 'select',
          placeholder: 'Select State',
          type: 'single',
          options: stateAbbreviations,
        },
        {
          name: 'lat',
          input: 'inputNumber',
          min: -90,
          max: 90,
          precision: 8,
          placeholder: 'Enter Latitude',
          rules: [
            {
              required: true,
              message: 'latitude is required',
            },
          ],
        },
        {
          name: 'lon',
          input: 'inputNumber',
          min: -180,
          max: 180,
          precision: 8,
          placeholder: 'Enter Longitude',
          rules: [
            {
              required: true,
              message: 'Longitude is required',
            },
          ],
        },
      ],
    },
    {
      step_title: 'Config',
      form_title: 'Terminal Configuration',
      section: [
        {
          name: 'split_load_terminals',
          input: 'select',
          type: 'multiple',
          placeholder: 'Select Split Load Terminals',
          options: createSelectOptions.split_load_terminals,
        },
        {
          name: 'supply_zones',
          input: 'select',
          type: 'multiple',
          placeholder: 'Select Supply Zone',
          options: createSelectOptions.supply_zone.filter((zone) => zone !== 'N/A'),
        },
        {
          name: 'authorized_carriers',
          placeholder: 'Select Carriers',
          type: 'multiple',
          options: createSelectOptions.authorized_carriers,
          input: 'select',
        },
      ],
    },
  ]
}
